import React from 'react'
import { useHistory } from 'react-router-dom'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import AddEnodeDevice from '../addEnodeDevice/AddEnodeDevice'

const HvacOnboarding: React.FC = () => {
	const history = useHistory()

	const goForward = () => history.push('/devices/add-device')

	return (
		<PageWrapper page='addHvac' appBarOptions={{ backPath: '/devices/add-device' }}>
			<AddEnodeDevice goForward={goForward} type='hvac' />
		</PageWrapper>
	)
}

export default HvacOnboarding
